document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.process-slider').forEach(function (root) {
    var sectionId = root.dataset.sectionId;
    var track = document.getElementById('ProcessSliderTrack-' + sectionId);
    var prevBtn = root.querySelector('.process-slider__arrow--prev');
    var nextBtn = root.querySelector('.process-slider__arrow--next');
    if (!track) return;

    function scrollByOne(direction) {
      var slide = track.querySelector('.process-slider__slide');
      var amount = slide ? slide.getBoundingClientRect().width + 16 : 300;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByOne(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByOne(1); });
  });
});